export const stripMarkup = str => {
  return str.replace(/(<([^>]+)>)/gi, '').trim()
}
